// extracted by mini-css-extract-plugin
module.exports = {"container":"h7re4eOOhBW226TLXsoX1","icon":"GybQcW27gAu3L2iYeekp6"};